export default __webpack_public_path__ + "8991e7c69ad6993c1f6d20ad57ae019d.png";